import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { SERIES, SERIES_REDEEM, VW_SERIES } from '../../models/series';
import { AUCTIONS } from '../../models/auctions';
import { VW_SERIES_SA } from '../../models/seriessa';
import { BOND_TYPES } from '../../models/bondtypes';
import { APP_USERS } from '../../models/user';
import { HeaderService } from '../../header.service';
import * as Globals from '../../globals';

declare var $: any;

@Component({
  selector: 'app-series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.css']
})
export class SeriesComponent implements OnInit {

  @Input() userProfile: any;
  loading: boolean = false;
  seri: SERIES;
  seriesRedeems: SERIES[];
  seriesRedeem: SERIES_REDEEM;
  selectedId: number;
  auction: AUCTIONS;
  seriessa: VW_SERIES_SA[];
  bondtypes: BOND_TYPES[];
  bondtype: BOND_TYPES;
  cds: any[];
  appUser: APP_USERS;
  price: string = '';
  couponBasis: string = '';
  freqCoupon: string = '';
  confirmBy: string = '';
  nominal: number;
  toggleBoolAI: boolean=true;
  toggleBoolNC: boolean=true;
  checked: boolean;
  checkItems: number = 0;
  dataSeries: any[];
  pricetypes: any[];
  onlinetypes: any[];
  @Input() cdAucType: any;
  @Input() aucId: number;
  @Input() seriesId: number;
  @Input() srId: number;
  @Input() authMenu: any;
  @Output() goToAp = new EventEmitter();
  @Output() setSeriesData = new EventEmitter();
  @Output() goToSubApList = new EventEmitter();
  @Output() refreshAuction = new EventEmitter;
  p: number = 1;
  constructor(
    private http: Http,
    public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService
  ) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
    this.newSeri();
    this.getPriceType();
    this.getOnlineType();
    this.getBondTypes();
  }

  goAp(id: number, name: string, seri:SERIES) {
    this.goToAp.emit({ id: id, name: name, parentSsId: 0 });
    this.setSeriesData.emit(this.seri);
  }

  goSubApList(id: number, name: string) {
    this.goToSubApList.emit({ id: id, name: name, parentSsId: id });
  }
  onChange(ev: any) {
    for (var i = 0; i < this.seriesRedeems.length; i++) {
      if (ev.target.value == this.seriesRedeems[i].SERIES_ID) {
        this.seriesRedeem.SR_ID = this.seriesRedeems[i].SR_ID;
        this.seriesRedeem.MAX_PCENT = this.seriesRedeems[i].MAX_PCENT;
        this.seriesRedeem.AUCTION_ID = this.seriesRedeems[i].AUCTION_ID;
        this.seriesRedeem.SERIES_ID = this.seriesRedeems[i].SERIES_ID;
        this.seriesRedeem.INCREMENTAL = this.seriesRedeems[i].INCREMENTAL;
        this.seriesRedeem.MIN_BID = this.seriesRedeems[i].MIN_BID;
        break;
      }
    }
    this.getSeries(ev.target.value);
  }

  onBTChange(bt) {
    for (var i = 0; i < this.bondtypes.length; i++) {
      if (bt.target.value == this.bondtypes[i].BT_ID) {
        this.nominal = this.bondtypes[i].PRINCIPAL;
        //this.getCouponBasic(this.bondtypes[i].CG_BASIS, this.bondtypes[i].CD_BASIS);
        //this.getCouponFreq(this.bondtypes[i].CG_FREQ, this.bondtypes[i].CD_FREQ);
        this.getCds(this.bondtypes[i].CG_BASIS, this.bondtypes[i].CD_BASIS);
        this.getCds(this.bondtypes[i].CG_FREQ, this.bondtypes[i].CD_FREQ);
      }
    }
  }

  onCheckedAI(ev) {
    if (ev.target.checked) {
      this.toggleBoolAI = false;
    }
    else {
      this.toggleBoolAI = true;
    }
  }

  onCheckedNC(ev) {
    if (ev.target.checked) {
      this.toggleBoolNC = false;
    }
    else {
      this.toggleBoolNC = true;
    }
  }

  getCheckItems() {
    this.checked = false;
    this.checkItems = 0;
    for (var i = 0; i < this.seriessa.length; i++) {
      if (this.seriessa[i].CHECKED) {
        this.checkItems++;
      }
    }
  }

  setConfirm(val: any) {
    this.dataSeries = [];
    for (var i = 0; i < this.seriessa.length; i++) {
      if (this.seriessa[i].CHECKED) {
        this.seriessa[i].CD_STATUS = val;
        this.dataSeries.push(this.seriessa[i]);
      }
    }
    if (this.dataSeries.length > 0) {
      this.http.put(Globals.serviceUrl + 'ritel/confirmseriessa?id=' + this.userProfile.USER_ID, this.dataSeries, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.checkItems = 0;
          this.checked = false;
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
          this.getSeriesSa();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

  getSeries(id: number) {
    this.seriesId = id;
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/series?id=' + this.seriesId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seri = res.json();
        this.seri.MATURITY_DATE = new Date(this.seri.SMATURITY_DATE);
        this.seri.MIN_HOLDING_PERIOD = new Date(this.seri.SMIN_HOLDING_PERIOD);
        this.seri.FIRST_COUPON_DATE = new Date(this.seri.SFIRST_COUPON_DATE);
        this.seri.PAYMENT_T_LIMIT = new Date(this.seri.SPAYMENT_T_LIMIT);
        this.seri.PAYMENT_GRACE = new Date(this.seri.SPAYMENT_GRACE);
        if (this.cdAucType == '2') {
          this.getSeriesRedeems();
        }
        this.getBondTypesById(this.seri.BT_ID);
        //this.getUser(this.seri.CONFIRM_BY);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeriesRedeems() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriesredeem?aucId=' + this.aucId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriesRedeems = res.json();
        if (this.seriesId > 0) {
          this.selectedId = this.seriesId;
          for (var i = 0; i < this.seriesRedeems.length; i++) {
            if (this.seriesId == this.seriesRedeems[i].SERIES_ID) {
              this.seriesRedeem.SR_ID = this.seriesRedeems[i].SR_ID;
              this.seriesRedeem.MAX_PCENT = this.seriesRedeems[i].MAX_PCENT;
              this.seriesRedeem.AUCTION_ID = this.seriesRedeems[i].AUCTION_ID;
              this.seriesRedeem.SERIES_ID = this.seriesRedeems[i].SERIES_ID;
              this.seriesRedeem.INCREMENTAL = this.seriesRedeems[i].INCREMENTAL;
              this.seriesRedeem.MIN_BID = this.seriesRedeems[i].MIN_BID;
              this.seriesRedeem.MIN_OWNERSHIP = this.seriesRedeems[i].MIN_OWNERSHIP;
              break;
            }
          }
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  newSeri() {
    this.seri = new SERIES(0, null, null, null, null, null, null, null, null, null, this.userProfile.USER_ID, 0, null, null, null, null, null, null, null, 19, null, 30, '1', null, null, this.userProfile.USER_ID, null, null, null, null, null, this.userProfile.USER_ID, null, null, null, null, null, 34, null, null );
    this.seriesRedeem = new SERIES_REDEEM(0, null, null, null, null, null, null);
  }

  getBondTypes() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/bondtypes?t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.bondtypes = res.json();
        if (this.seriesId > 0) {
          this.getSeries(this.seriesId);
        } else {
          if (this.cdAucType == '2') {
            this.getSeriesRedeems();
          }
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getBondTypesById(id: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/bondtypes?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.bondtype = res.json();
        this.nominal = this.bondtype.PRINCIPAL;
        this.getCds(this.bondtype.CG_BASIS, this.bondtype.CD_BASIS);
        this.getCds(this.bondtype.CG_FREQ, this.bondtype.CD_FREQ);
        this.getSeriesSa();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getPriceType() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=19&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.pricetypes = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getOnlineType() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=34&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.onlinetypes = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCds(cgNo: number, cdcode: string) {
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.cds = res.json();
        for (var i = 0; i < this.cds.length; i++) {
          if (cgNo == 20) {
            if (cdcode == this.cds[i].CD_CODE) {
              this.couponBasis = this.cds[i].SYS_NAME;
            }
          } else {
            if (cdcode == this.cds[i].CD_CODE) {
              this.freqCoupon = this.cds[i].SYS_NAME;
            }
          }
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getUser(userId: number) {
    this.http.get(Globals.serviceUrl + 'ref/user?id=' + userId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.appUser = res.json();
          if (userId == this.appUser.USER_ID) {
            this.confirmBy = this.appUser.USERNAME;
          }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?seriesId=' + this.seri.SERIES_ID + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  loadParent(val: any) {
    this.refreshAuction.emit({ seriId: this.seri.SERIES_ID, seriesName: this.seri.SERIES_NAME, mode: val });
  }

  saveSeries() {
    this.loading = true;
    this.seri.SMATURITY_DATE = Globals.formatDate(this.seri.MATURITY_DATE);
    this.seri.SMIN_HOLDING_PERIOD = Globals.formatDate(this.seri.MIN_HOLDING_PERIOD);
    this.seri.SFIRST_COUPON_DATE = Globals.formatDate(this.seri.FIRST_COUPON_DATE);
    this.seri.SPAYMENT_T_LIMIT = Globals.formatDateTime(this.seri.PAYMENT_T_LIMIT);
    this.seri.SPAYMENT_GRACE = Globals.formatDateTime(this.seri.PAYMENT_GRACE);
    if (this.cdAucType == '1') {
      if (this.seriesId == 0) {
        this.seri.AUCTION_ID = this.aucId;
        this.http.post(Globals.serviceUrl + 'ritel/series', this.seri, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.seri = res.json();
            this.toastr.success('Data berhasil disimpan');
            this.seriesId = this.seri.SERIES_ID;
            this.loadParent(1);
            this.getSeries(this.seriesId);
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      } else {
        this.seri.UPD_BY = this.userProfile.USER_ID;
        this.http.put(Globals.serviceUrl + 'ritel/series?id=' + this.seri.SERIES_ID, this.seri, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.toastr.success('Data berhasil disimpan');
            this.loadParent(1);
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
    } else {
      if (this.seriesRedeem.SR_ID == 0) {
        this.seriesRedeem.AUCTION_ID = this.aucId;
        this.http.post(Globals.serviceUrl + 'ritel/seriesredeem', this.seriesRedeem, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.seriesRedeem = res.json();
            this.toastr.success('Data berhasil disimpan');
            this.loadParent(1);
            this.getSeriesRedeems();
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      } else {
        this.http.put(Globals.serviceUrl + 'ritel/seriesredeem?id=' + this.seriesRedeem.SR_ID, this.seriesRedeem, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.toastr.success('Data berhasil disimpan');
            this.loadParent(1);
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
      }
    }

  }

  deleteSeries() {
    if (this.cdAucType == '1') {
      this.http.delete(Globals.serviceUrl + 'ritel/series?id=' + this.seri.SERIES_ID, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          $('#modal').modal('hide');
          this.toastr.success('Data berhasil dihapus');
          this.loadParent(0);
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      this.http.delete(Globals.serviceUrl + 'ritel/seriesredeem?id=' + this.seri.SERIES_ID, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          $('#modal').modal('hide');
          this.toastr.success('Data berhasil dihapus');
          this.loadParent(0);
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/auction/series/series.component.ts